module.exports = __webpack_public_path__ + "img/step1.44fe17c3.svg";